<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" role="dialog" aria-modal="true" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--rpt">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-shopping-cart-2-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Sélectionnez un rapport sur les achats</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="rpt-list">

                        <div class="rpt-option">
                            <span class="rpt-option__icon rpt-option__icon--primary"><i class="ri-bar-chart-line"></i></span>
                            <span class="rpt-option__body">
                                <span class="rpt-option__title">Suivi de vos achats</span>
                            </span>
                            <i class="ri-arrow-right-line rpt-option__arrow"></i>
                        </div>

                        <div class="rpt-option">
                            <span class="rpt-option__icon rpt-option__icon--success"><i class="ri-cash-line"></i></span>
                            <span class="rpt-option__body">
                                <span class="rpt-option__title">Répartition du coût d'achat des articles par fournisseurs</span>
                            </span>
                            <i class="ri-arrow-right-line rpt-option__arrow"></i>
                        </div>

                        <div class="rpt-option">
                            <span class="rpt-option__icon rpt-option__icon--info"><i class="ri-file-list-3-line"></i></span>
                            <span class="rpt-option__body">
                                <span class="rpt-option__title">Relevé des factures fournisseurs</span>
                            </span>
                            <i class="ri-arrow-right-line rpt-option__arrow"></i>
                        </div>

                    </div>

                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


    <!--modalopenform ref="modalopenform"  ></modalopenform>
    <modalimpressiondoc ref="modalimpressiondoc"  ></modalimpressiondoc-->

</template>

<script>



    /*

    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    import modalimpressiondoc from "@/components/views/pages/stock/mvtstock/modal_etatdocstock";

    */


    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {

        },
        computed:{


        },
        components: {

        },

        data() {
            return {
                isdisplay:false
            };
        },
        methods: {


            btnimpression(value){

                 this.$refs.modalimpressiondoc.show(value);

            },

            btnopen(value){


                let titlemodal="Document "+value.numdoc

                let Item=value

                this.$refs.modalopenform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="RAPPORT SUR ACHATS"
                this.isdisplay=true;

            },








        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--rpt { max-width:620px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Liste d'options de rapports */
.rpt-list { display:flex; flex-direction:column; gap:0.6rem; }
.rpt-option { width:100%; display:flex; align-items:center; gap:0.85rem; padding:0.8rem 0.9rem; background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius); cursor:pointer; text-align:left; transition:border-color .15s, box-shadow .15s, background-color .15s; }
.rpt-option:hover { border-color:rgb(var(--primary) / 0.45); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); background:rgb(var(--primary) / 0.03); }
.rpt-option__icon { flex-shrink:0; width:44px; height:44px; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); font-size:1.35rem; transition:transform .15s; }
.rpt-option:hover .rpt-option__icon { transform:scale(1.08); }
.rpt-option__icon--primary { background:rgb(var(--primary) / 0.10); color:rgb(var(--primary)); }
.rpt-option__icon--success { background:rgb(var(--success) / 0.12); color:rgb(var(--success)); }
.rpt-option__icon--info { background:rgb(var(--info) / 0.12); color:rgb(var(--info)); }
.rpt-option__body { flex:1; min-width:0; display:flex; flex-direction:column; }
.rpt-option__title { font-size:0.88rem; font-weight:600; color:var(--cf-ink-strong); transition:color .15s; }
.rpt-option:hover .rpt-option__title { color:rgb(var(--primary)); }
.rpt-option__arrow { flex-shrink:0; font-size:1.1rem; color:var(--cf-faint); transition:color .15s, transform .15s; }
.rpt-option:hover .rpt-option__arrow { color:rgb(var(--primary)); transform:translateX(3px); }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media screen and (max-width: 768px) {
    .cf-dialog--rpt { max-width:100%; }
}

</style>
